/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page MNG_Accident004
 * @created at      :   2025/08/01
 * @created by      :   DaoNX
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
const dataInit = {
    working_date_start: '',
    company: 'ムーヴ',
    period: 1
};
export default {
    namespaced: true,
    state: {
        data: { ...dataInit },
        listData: [
            {
                col1: '',
                col2: '1235',
                col3: '休日申請',
                col4: '2025/07/01 13:12',
                col5: '2025年8月22日　所定休①',
                col6: '江保',
                col7: '2025/07/01 13:12',
                col8: '浅野',
                col9: '',
                col10: '茶田',
                col11: '',
                col12: '承認中'
            },
            {
                col1: '',
                col2: '1236',
                col3: '休日申請',
                col4: '2025/07/01 13:12',
                col5: '2025年8月23日　所定休②',
                col6: '江保',
                col7: '2025/07/01 13:12',
                col8: '浅野',
                col9: '',
                col10: '茶田',
                col11: '',
                col12: '承認中'
            },
            {
                col1: '',
                col2: '1237',
                col3: '休日申請',
                col4: '2025/07/01 13:12',
                col5: '2025年8月24日　所定休③',
                col6: '江保',
                col7: '2025/07/01 13:12',
                col8: '浅野',
                col9: '',
                col10: '茶田',
                col11: '',
                col12: '承認中'
            },
            {
                col1: '',
                col2: '1238',
                col3: '休日申請',
                col4: '2025/07/01 13:12',
                col5: '2025年8月25日　所定休③',
                col6: '江保',
                col7: '2025/07/01 13:12',
                col8: '浅野',
                col9: '',
                col10: '茶田',
                col11: '',
                col12: '承認中'
            },
            {
                col1: '',
                col2: '1239',
                col3: '経費申請',
                col4: '2025/07/01 13:12',
                col5: '2025/08/13　宿舎購入代　￥24,800',
                col6: '江保',
                col7: '2025/07/01 13:12',
                col8: '浅野',
                col9: '',
                col10: '茶田',
                col11: '',
                col12: '承認中'
            },
            {
                col1: '',
                col2: '1240',
                col3: '出勤の訂正',
                col4: '2025/07/03 10:05',
                col5: '2025年7月03日　10:00　出勤の訂正',
                col6: '江保',
                col7: '2025/07/01 13:12',
                col8: '浅野',
                col9: '',
                col10: '茶田',
                col11: '',
                col12: '承認待ち'
            },
            {
                col1: '',
                col2: '1201',
                col3: '有休申請',
                col4: '2025/06/25 10:12',
                col5: '2025年8月05日　有休申請',
                col6: '江保',
                col7: '2025/07/01 13:12',
                col8: '浅野',
                col9: '2025/07/01 13:12',
                col10: '茶田',
                col11: '2025/07/01 13:12',
                col12: '承認済'
            },
            {
                col1: '',
                col2: '1200',
                col3: '有休申請',
                col4: '2025/06/25 10:13',
                col5: '2025年8月06日　有休申請',
                col6: '江保',
                col7: '2025/07/01 13:12',
                col8: '浅野',
                col9: '2025/07/01 13:12',
                col10: '茶田',
                col11: '2025/07/01 13:12',
                col12: '承認済'
            },
            {
                col1: '',
                col2: '1205',
                col3: '有休申請',
                col4: '2025/06/25 10:13',
                col5: '2025年8月07日　有休申請',
                col6: '江保',
                col7: '2025/07/01 13:12',
                col8: '浅野',
                col9: '',
                col10: '茶田',
                col11: '2025/07/01 13:12',
                col12: '否認'
            }
        ],
        options: {
            status: [
                {
                    code: 1,
                    name: '承認待ち'
                },
                {
                    code: 2,
                    name: '承認済'
                },
                {
                    code: 3,
                    name: '否認'
                }
            ]
        },
        paginationData: {
            pageNo: 1,
            pageSize: 999,
            totalRows: 0,
            msgNoData: ''
        }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.paginationData.pageNo = 1;
            state.paginationData.pageSize = 999;
            state.paginationData.totalRows = 0;
            state.paginationData.msgNoData = '';
        },
        setAccidentAnnouncementData(state, data) {
            state.accidentAnnouncementData = data ?? [];
        },
        setPageNavigation(state, data) {
            state.paginationData.pageNo = parseInt(data.page);
            state.paginationData.pageSize = parseInt(data.pageSize);
            state.paginationData.totalRows = parseInt(data.totalRows);
            state.paginationData.msgNoData = parseInt(data.totalRows) == 0 ? '該当するデータが存在しません。' : '';
        },
        setCombobox(state, data) {
            // var status = data.filter((item) => item.code !== '0');
            state.draftOption = data.filter((item) => item.code == '0');
            // state.options.status = status;
        }
    },
    actions: {
        actionSearch(context, request) {
            try {
                // Fake data for development
                const fakeData = {
                    Code: 200,
                    Data: {
                        accidentAnnouncementData: [],
                        paging: {
                            page: 1,
                            pageSize: 999,
                            totalRows: 6
                        }
                    }
                };

                context.commit('setAccidentAnnouncementData', fakeData.Data.accidentAnnouncementData);
                context.commit('setPageNavigation', fakeData.Data.paging);

                // callback
                if (request.callback) {
                    request.callback(fakeData);
                }
            } catch (e) {
                console.error('Search: ' + e.message);
            }
        }
    }
};
